// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"BookSlotForm_formWrapper__c0UfG","infoText":"BookSlotForm_infoText__Yt361","submitButton":"BookSlotForm_submitButton__ir55f"};